(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  // VINEY (T679 rule 11, session 4): Back carries the photo home. Horizon names the tapped card's photo and
  // the product page's first photo for the trip in, then removes the names once it has landed, so Back
  // had nothing to travel. Leaving a product page by Back or Forward names its first photo again (the
  // stable data-vn-vt-home mark from snippets/product-media-gallery-content.liquid) and remembers the
  // product; the page that comes back names only that product's card photo, and only when it is on the
  // screen (otherwise only the fade). One name per page, or the browser drops the transition.
  const VN_BACK = 'vn-vt-back';
  const vnOnScreen = (/** @type {Element} */ el) => {
    const r = el.getBoundingClientRect();
    return el.getClientRects().length > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  };
  window.addEventListener('pageswap', (event) => {
    const { viewTransition, activation } = /** @type {PageSwapEvent} */ (event);
    if (!viewTransition || activation?.navigationType !== 'traverse') return;
    const home = [...document.querySelectorAll('[data-vn-vt-home]')].find(vnOnScreen);
    if (!home) return;
    document.querySelectorAll('[data-view-transition-triggered]').forEach((el) => el.removeAttribute('data-view-transition-triggered'));
    home.setAttribute('data-view-transition-type', 'product-image-transition');
    home.setAttribute('data-view-transition-triggered', 'true');
    sessionStorage.setItem(VN_BACK, home.getAttribute('data-vn-vt-home') || '');
  });
  window.addEventListener('pagereveal', (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);
    const id = sessionStorage.getItem(VN_BACK);
    sessionStorage.removeItem(VN_BACK);
    if (!viewTransition || !id) return;
    // a page restored from the back/forward cache still carries the names it left with: clear them first
    document.querySelectorAll('[data-view-transition-type="product-image-transition"]').forEach((el) => {
      el.removeAttribute('data-view-transition-type');
      el.removeAttribute('data-view-transition-triggered');
    });
    const card = [...document.querySelectorAll(`[data-view-transition-to-main-product][data-product-id="${CSS.escape(id)}"]`)].find(vnOnScreen);
    card?.setAttribute('data-view-transition-type', 'product-image-transition');
  });

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
